import { SearchIncrementType } from './searchIncrementType';
import { SearchIncrement } from './searchIncrement';
import { ProductRate } from './productRate';

export interface ProductRateValues {
    cantidad: number;
    preArt: number;
    precioConDescuento: number;
    precioConDescuentoEIncremento: number;
    precioSinDescuento: number;
    precioCantidad: number;
    preDto1: number;
    preDto2: number;
    preDto3: number;
    preDto4: number;
    preDto5: number;
    preIde: string;
    preOfe: boolean;
    prePre: number;
    prePrm: number;
    preSst: number;
    preTar: number;
    increment: SearchIncrement;
    precioMostrarBusqueda: number;
    precioMostrarPedido: number;
}


export class ProductRateValuesHelper {

    static create(obj: Object = {}): ProductRateValues {
        const ini = {
            cantidad: null,
            preArt: null,
            precioConDescuento: null,
            precioConDescuentoEIncremento: null,
            precioSinDescuento: null,
            precioCantidad: null,
            preDto1: null,
            preDto2: null,
            preDto3: null,
            preDto4: null,
            preDto5: null,
            preIde: null,
            preOfe: null,
            prePre: null,
            prePrm: null,
            preSst: null,
            preTar: null,
            increment: new SearchIncrement(),
            precioMostrarBusqueda: null,
            precioMostrarPedido: null,
        };

        return Object.assign(ini, obj);
    }

    static getPrecioMostrarBusqueda(productRate: ProductRateValues): number {
        let precio = productRate.precioMostrarBusqueda;
        if (productRate.increment && productRate.increment.type === SearchIncrementType.Value && productRate.increment.value !== 0) {
            precio += productRate.increment.value;
        }

        // Increment type percentage
        if (productRate.increment && productRate.increment.type === SearchIncrementType.Percentage && productRate.increment.value !== 0) {
            precio *= (productRate.increment.value / 100) + 1;
        }

        return precio;
    }
}
